import { useConfig } from '@kikoda/generated-config-hooks';
import { WebConfig } from 'web-config';
import { useGetObject } from './useGetObject';

const publicPrefix = 'public|';

export function useGetProtectedObject(url: string | null | undefined) {
    const { key, identityId } = separateUrl(url);

    const objectUrl = useGetObject(key, { level: 'protected', identityId });
    const publicUrl = useGetPublicUrl(url);

    if (url && url.startsWith(publicPrefix)) {
        return publicUrl;
    }

    return objectUrl;
}

function separateUrl(url: string | null | undefined): { key: string | undefined; identityId: string | undefined } {
    if (!url) {
        return { key: undefined, identityId: undefined };
    }

    const baseUrl = url.split('?')[0];
    const index = baseUrl.indexOf('|');

    return {
        key: baseUrl.slice(index + 1),
        identityId: index > 0 ? baseUrl.slice(0, index) : undefined,
    };
}

function useGetPublicUrl(url: string | null | undefined): string {
    const config = useConfig<WebConfig>();

    if (!url) {
        console.log('getPublicUrl: url is null or undefined');
        return '';
    }

    // split off prefix if it exists
    if (url && url.startsWith(publicPrefix)) {
        url = url.slice(publicPrefix.length);
    }

    if (!config.additionalConfig?.publicImageBaseUrl) {
        console.log('getPublicUrl: publicImageBaseUrl is not defined in config, returning url as is');
        return url;
    }

    return config.additionalConfig?.publicImageBaseUrl + url;
}
